import { FC, useState } from 'react'
import { Button, FetchState, Label, useModal } from '../../../../../../components'
import { PrescricaoView } from '../../core/_model'
import { FontSize, generatePdfUrl, PrescricaoType } from '../../../../../../../_metronic/helpers'
import { downloadAPAC, downloadLME, downloadTermo } from '../../core/_requests'
import { ArquivoDto } from '../../../../atendimento/core/_models'
import { downloadAuthPrescricao } from '../../../../../public/prescricao/core/_request'
import { rotuloNumeroSncr } from '../../../../sncr/core/_models'

export const PdfModal: FC = () => {
  const { fetchStates } = useModal()
  const { data: prescricoes } = (fetchStates['prescricoes'] || {}) as FetchState<PrescricaoView[]>
  const [pdfPath, setPdfPath] = useState<string>('')

  const handlePrescricao = async (prescricao: PrescricaoView) => {
    const file = await downloadAuthPrescricao(prescricao.codigoAcesso, prescricao.codigoPaciente)
    setFile(file)
  }

  const handleLME = async (id: number) => {
    const file = await downloadLME(id)
    setFile(file)
  }

  const handleAPAC = async (id: number) => {
    const file = await downloadAPAC(id)
    setFile(file)
  }

  const handleDocumento = async (idPrescricao: number, idDocumento: number) => {
    const file = await downloadTermo(idPrescricao, idDocumento)
    setFile(file)
  }

  const setFile = (file: ArquivoDto) => {
    if (file.url) {
      window.open(file.url, '_blank')
    } else if (file?.contentBase64) {
      const url = generatePdfUrl(file.contentBase64, file.type)
      if (url) setPdfPath(url)
    }
  }

  return (
    <div>
      {prescricoes?.map((prescricao) => (
        <div key={prescricao.id}>
          <div className='d-flex justify-content-between align-items-center mb-3'>
            <div className='d-flex flex-column'>
              <Label size={FontSize.Medium}>
                {prescricao.tipo === PrescricaoType.Medicamento ||
                prescricao.tipo === PrescricaoType.Especial
                  ? 'Prescrição de medicamentos'
                  : prescricao.tipo === PrescricaoType.Notificacao
                  ? 'Notificação de receita'
                  : prescricao.tipo === PrescricaoType.Retencao
                  ? 'Receita com retenção'
                  : prescricao.tipo === PrescricaoType.Formula
                  ? 'Prescrição de fórmulas'
                  : prescricao.tipo === PrescricaoType.Exame
                  ? 'Prescrição de exames'
                  : prescricao.tipo === PrescricaoType.Orientacoes
                  ? 'Prescrição de orientações'
                  : 'Documento gerado'}
              </Label>
              {prescricao.numeroSncr && (
                <span className='text-muted fs-8'>
                  Nº SNCR {rotuloNumeroSncr(prescricao.numeroSncr, prescricao.tipoReceitaSncr)}
                </span>
              )}
            </div>
            <Button
              className='btn-primary'
              size='btn-sm'
              onClick={() => handlePrescricao(prescricao)}
            >
              Visualizar
            </Button>
          </div>
          {prescricao.documentos && prescricao.documentos.length > 0 && (
            <>
              {prescricao.documentos.map((doc) => (
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <Label size={FontSize.Medium}>{doc.descricao}</Label>
                  <Button
                    className='btn-primary'
                    size='btn-sm'
                    onClick={() => handleDocumento(prescricao.id, doc.id)}
                  >
                    Visualizar
                  </Button>
                </div>
              ))}
            </>
          )}
          {prescricao.lme && (
            <div className='d-flex justify-content-between align-items-center mb-3'>
              <Label size={FontSize.Medium}>{prescricao.lme.descricao}</Label>
              <Button
                className='btn-primary'
                size='btn-sm'
                onClick={() => handleLME(prescricao.id)}
              >
                Visualizar
              </Button>
            </div>
          )}
          {prescricao.apac && (
            <div className='d-flex justify-content-between align-items-center mb-3'>
              <Label size={FontSize.Medium}>{prescricao.apac.descricao}</Label>
              <Button
                className='btn-primary'
                size='btn-sm'
                onClick={() => handleAPAC(prescricao.id)}
              >
                Visualizar
              </Button>
            </div>
          )}
        </div>
      ))}
      {pdfPath && (
        <object
          width='100%'
          height='450px'
          data={pdfPath + '#navpanes=0&scrollbar=0'}
          aria-label='Visualizacao da prescricao em PDF'
        >
          Visualizacao da prescricao em PDF
        </object>
      )}
    </div>
  )
}
